export enum SelectionTypeEnum {
    SINGLE = "SINGLE",
    MULTIPLE = "MULTIPLE",
}
